import { findPreset, presetsLength } from '@/store/presets/getters'
import { del, get, getAll, patch, post } from '@/utils/api'

const normalizePreset = record => ({
  id: record.getId(),
  description: record.get('description'),
  duration: record.get('duration'),
  subject: record.get('subject'),
  student: record.get('student')
})

const getPresets = ({ commit, state }, force) => {
  if (presetsLength(state) < 1 || !!force) {
    getAll('Presets').then(presets => {
      const returnPresets = presets.map(s => normalizePreset(s))
      commit('SET_PRESETS', returnPresets)
      commit('IS_LOADED')
    })
  }
}

const getPreset = ({ commit }, id) => {
  const presetFromState = findPreset(id)
  if (presetFromState) {
    return presetFromState
  }

  get('Presets', id).then(preset => {
    commit('SET_PRESET', normalizePreset(preset))
  })
}

const addPreset = ({ commit }, preset) => {
  post('Presets', { fields: preset }).then(presets => {
    presets.forEach(s => {
      commit('ADD_PRESET', normalizePreset(s))
    })
  })
}

const deletePreset = ({ commit }, id) => {
  del('Presets', id).then(s => {
    commit('DELETE_PRESET', s.id)
  })
}

const editPreset = ({ commit }, preset) => {
  patch('Presets', preset).then(s => {
    commit('EDIT_PRESET', normalizePreset(s))
  })
}

export default {
  addPreset,
  deletePreset,
  editPreset,
  getPreset,
  getPresets
}
